import React, { useContext } from 'react'
import styled from 'styled-components'
import { CreationToolsContext } from '../../../../../manager'
import CreationToolUploadField from '../../../../../types/upload-field'
import CreationToolUserRestriction from '../../../../../types/user-restriction'
import { GridBlock } from '../../../../blocks'
import TagsField from './fields/tags'
import UsernameField from './fields/username'

const FIELDS = [CreationToolUploadField.Tags, CreationToolUploadField.Username]

const Fields = styled(GridBlock)`
    gap: 30px;
    margin: 30px 0;
`

const CreationCaptureInfoCustomFont = () => {
    const { userRestrictionAccess } = useContext(CreationToolsContext)

    // filter out any fields that the user doesn't have access to.
    const fields = FIELDS.filter(field => {
        const userRestriction = CreationToolUploadField.userRestriction(field)
        return CreationToolUserRestriction.hasAccess(userRestriction, userRestrictionAccess)
    })

    const fieldComponents = fields.map(field => {
        switch (field) {
            case CreationToolUploadField.Tags:
                return TagsField
            case CreationToolUploadField.Username:
                return UsernameField
        }
    })

    return (
        <Fields columns={2}>
            {fieldComponents.map((Field, i) => (Field ? <Field key={fields[i]} field={fields[i]} /> : null))}
        </Fields>
    )
}

export default CreationCaptureInfoCustomFont
